import React from "react";
import IConfirmationActions from "./IConfirmationActions";
import * as style from "./ConfirmationActionsStyle.module.scss";
import { classNames } from "@features/utils/reactFunctions";
import MessageService from "@services/Message.service";
import { TReducers } from "@features/reducers";
import { connect } from "react-redux";

const ConfirmationActions: React.FunctionComponent<IConfirmationActions> = (
  props
) => {
  const { labels, red, token, onError, onSuccess } = props;

  const isUk = props.country === "GB";

  const isRed = (buttonLocation: "left" | "right" | "not-red") => {
    if (buttonLocation === "not-red") {
      return;
    }

    return red === buttonLocation && style.actionButtonRed;
  };
  const callApi = (action: "confirmation" | "rejection") => {
    MessageService.handleConfirmation(token, action)
      .then((res) => onSuccess(true))
      .catch((err) => onError("confirm_error"));
  };

  return (
    <div className={style.confirmationActions}>
      <button
        className={classNames(
          style.actionButton,
          isRed(isUk ? "not-red" : "left")
        )}
        onClick={() => callApi("rejection")}
      >
        {(labels && labels[0]) || "Cancel"}
      </button>
      <button
        className={classNames(style.actionButton, isRed("right"))}
        onClick={() => callApi("confirmation")}
      >
        {(labels && labels[1]) || "Confirm"}
      </button>
    </div>
  );
};

const mapStateToProps = (store: TReducers) => ({
  country: store.userInfo.country,
});

export default connect(mapStateToProps)(ConfirmationActions);
ConfirmationActions;
